<template>
  <div class="npb-voice-flash-call-container">
    <div v-if="isSMSPanel" class="npb-voice-flash-call-image__sms"></div>
    <div v-else-if="isFlashCallPanel" class="npb-voice-flash-call-image__flash"></div>
    <div v-else-if="isVoiceCallPanel" class="npb-voice-flash-call-image__voice"></div>
    <div class="npb-voice-flash-call-content">
      <div v-if="isSMSPanel">
        <div class="npb-voice-flash-call-content__title">
          <i18n val="second_step_thumbnail_sms_info_title"></i18n>
        </div>
        <div class="npb-voice-flash-call-content__text">
          <i18n val="second_step_thumbnail_sms_info_text"></i18n>
        </div>
      </div>
      <div v-else-if="isFlashCallPanel">
        <div class="npb-voice-flash-call-content__title">
          <i18n val="second_step_thumbnail_flash_call_info_title"></i18n>
        </div>
        <div class="npb-voice-flash-call-content__text">
          <span><i18n val="second_step_thumbnail_flash_call_info_text_example"></i18n> </span>
          <span class="npb-voice-flash-call_content__text-phone npb-nowrap">
            <span><i18n val="second_step_thumbnail_flash_call_info_text_phone"></i18n></span> <span class="npb-voice-flash-call-content__text-circled">4359</span>
          </span>
        </div>
        <div class="npb-voice-flash-call-content__text">
          <i18n val="second_step_thumbnail_flash_call_info_text_extend"></i18n>
        </div>
      </div>
      <div v-else-if="isVoiceCallPanel">
        <div class="npb-voice-flash-call-content__title">
          <i18n val="second_step_thumbnail_voice_call_info_title"></i18n>
        </div>
        <div class="npb-voice-flash-call-content__text">
          <i18n val="second_step_thumbnail_voice_call_info_text"></i18n>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import I18n from "./i18n.vue";

    export default {
      components: {I18n},
      props: {
        isSMSPanel: Boolean,
        isFlashCallPanel: Boolean,
        isVoiceCallPanel: Boolean,
      },
    }
</script>

<style scoped>
.npb-pincode-target {
    direction: ltr;
    display: inline-block;
}
</style>
